import client from "../../tina/__generated__/client";

// Tina connections are paginated. Daily publishing must not silently lose old
// articles, directory cards, or static routes after the first page fills up.
async function collect(query, field: string, variables = {}) {
  const first = await query({ ...variables, first: 100 });
  const edges = [...(first.data[field].edges || [])];
  let pageInfo = first.data[field].pageInfo;
  const cursors = new Set<string>();
  while (pageInfo.hasNextPage) {
    if (!pageInfo.endCursor || cursors.has(pageInfo.endCursor))
      throw new Error(`Invalid ${field} pagination cursor`);
    cursors.add(pageInfo.endCursor);
    const next = await query({
      ...variables,
      first: 100,
      after: pageInfo.endCursor,
    });
    edges.push(...(next.data[field].edges || []));
    pageInfo = next.data[field].pageInfo;
  }
  return {
    ...first,
    data: { ...first.data, [field]: { ...first.data[field], edges, pageInfo } },
  };
}

export const getAllPosts = (variables = {}) =>
  collect(client.queries.postConnection, "postConnection", variables);
export const getAllLessons = (variables = {}) =>
  collect(client.queries.lessonConnection, "lessonConnection", variables);
export const getAllCategories = (variables = {}) =>
  collect(client.queries.categoryConnection, "categoryConnection", variables);
